import { registerQuery } from 'data-fetching-client';
import { getTranslatedGrowthFeaturesFromProductsRpc } from 'feature-store-service-types';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
export const GET_FEATURES_BY_API_NAMES = registerQuery({
  fieldName: 'features',
  args: ['productApiNames', 'i18nLangLocale'],
  fetcher({
    productApiNames,
    i18nLangLocale
  }) {
    const rpcClient = createRpcClientV2({
      hubHttpClient: noAuthHttp
    });
    return rpcClient.call(getTranslatedGrowthFeaturesFromProductsRpc, {
      queryParameters: {
        productApiNames,
        i18nLangLocale
      }
    });
  }
});